// extracted by mini-css-extract-plugin
module.exports = {"buttons":"Buttons_buttons__22yrG","applyButton":"Buttons_applyButton__2kqzI","okButton":"Buttons_okButton__36prE","cancelButton":"Buttons_cancelButton__24Y6-"};